import { useEffect, useMemo } from 'react';
import { MultiStep, StepData, StepHeaderProps, useStepContext } from '@frontend/design-system';
import { stepStyles } from '../../../../components/step.styles';
import { EnrollmentBaseStepProps } from '../../enrollment-multi-step.types';

export const EnrollmentBaseStep = ({ children, header: headerProps, ...props }: EnrollmentBaseStepProps) => {
  const header = useMemo<StepHeaderProps>(() => {
    return {
      showCancelAction: false,
      ...headerProps,
    };
  }, [headerProps]);

  return (
    <MultiStep.Step {...props} header={header} css={stepStyles.step}>
      <EnrollmentBaseStepSyncStepData label={props.label}>{children}</EnrollmentBaseStepSyncStepData>
    </MultiStep.Step>
  );
};

const EnrollmentBaseStepSyncStepData = ({ children, label }: React.PropsWithChildren<{ label: StepData['label'] }>) => {
  const { setStepData, stepData } = useStepContext();

  useEffect(() => {
    if (label !== stepData.label) {
      setTimeout(() => {
        setStepData({ ...stepData, label });
      }, 10);
    }
  }, [label, stepData?.label]);

  return <>{children}</>;
};
